import { render, staticRenderFns } from "./PositionsViewSelector.vue?vue&type=template&id=4e296b46&scoped=true"
import script from "./PositionsViewSelector.vue?vue&type=script&lang=js"
export * from "./PositionsViewSelector.vue?vue&type=script&lang=js"
import style0 from "./PositionsViewSelector.vue?vue&type=style&index=0&id=4e296b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e296b46",
  null
  
)

export default component.exports